let OBSERVERSHIP_APPLICATION = {
   "address": "",
   "addressTwo": "",
   "applicantCity": "",
   "applicantState": "", 
   "applicantZipCode": "",
   "applicantPhone": "",
   "citizenshipCountry": "",
   "legalSex": "",
   "englishProficiency": "",
   "usmleExams": "",
   
   applicantEducation: 
     { "degreeOne":"",
	   "institutionOne":"",
	   "startMonthDegreeOne":"",
	   "startYearDegreeOne":"",
	   "startDateDegreeOne":"",	
	   "endMonthDegreeOne":"",   
	   "endYearDegreeOne":"",  
	   "endDateDegreeOne":"",
	   "educationDatesDegreeOne":"",
        "degreeTwo":"",
	   "institutionTwo":"",
	   "startMonthDegreeTwo":"",
	   "startYearDegreeTwo":"",
	   "startDateDegreeTwo":"",
	   "endMonthDegreeTwo":"",   
	   "endYearDegreeTwo":"",  
	   "endDateDegreeTwo":"",
	   "educationDatesDegreeTwo":"",
	   "degreeThree":"",
       "institutionThree":"",
       "startMonthDegreeThree":"",
	   "startYearDegreeThree":"",
	   "startDateDegreeThree":"",
	   "endMonthDegreeThree":"",   
	   "endYearDegreeThree":"", 
	   "endDateDegreeThree":"",
	   "educationDatesDegreeThree":""},
   "currentTitle": "",
   "department":"",
   "currentInstitution":"",
   "positionCountry":"",
   "startDate":"",
   "positionStartMonth" : "",
   "positionStartYear" : "",
   "preferredDepartment":"",
   "minDesiredDuration":"",
   "maxDesiredDuration":"",
   "preferredStartMonth":"",
   "preferredStartYear":"",
   "preferredStart":"",
   "preferredEndMonth":"",
   "preferredEndYear":"",
   "preferredEnd":"",
   "preferredMonths":"",
   "availableStartMonth":"",
   "availableStartYear":"",
   "availableStart":"",
   "availableEnd":"",
   "availableEndMonth":"",
   "availableEndYear":"",
   "availableMonths":"",
   "additionalComments":"",
   "termsAndConditions":"",
   "hearAbout":"",
   "cvUploaded":"",
   "sopUploaded":"",
   "losUploaded":"",
   "rPhotographUploaded":""
   
};

export {OBSERVERSHIP_APPLICATION};